import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';
import { CheckCircleOutlined } from '@ant-design/icons';

const fetch = (keyword, callback) => {
  _setAxios("role/table", "POST", {
    "pagination": {
      "current": 1,
      "pageSize": 10000,
      "total": 0
    },
    "search": keyword ? keyword : null,
    "sorting": [
      {
        "field": "name",
        "sort": "ASC",
        "urutan": "1"
      }
    ]
  })
    .then(body => {
      let results = []
      body.data?.list?.forEach(row => {
        results.push({
          value: row.id,
          label: (
            <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{row.name}</span>
              {row.is_used === "1" && <CheckCircleOutlined />}
            </span>
          ),
        })
      });

      callback(results);
    })
};
const SearchInput = (props) => {
  return (
    <Select
      {...props}
      showSearch
      allowClear
      placeholder={
        props.placeholder ? props.placeholder : 'Pilih jabatan'
      }
      style={props.style ? props.style : { width: '100%' }}
      defaultActiveFirstOption={false}
      filterOption={false}
      notFoundContent={null}
    />
  );
};
const SelectRoles = ({ ...props }) => {
  const [data, setData] = useState([]);
  const handleSearch = (newValue) => {
    fetch(newValue, setData);
  };

  useEffect(() => {
    fetch(null, setData);
  }, []);

  return <SearchInput
    {...props}
    onSearch={handleSearch}
    options={data}
  />
}

export default SelectRoles;